import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { backdropFilter } from 'helpers/browser'

const Badge = ({ text, icon, style, classNames }) => (
  <div
    className={classnames(
      'flex-shrink-0 bg-midnightBlack bg-opacity-70 px-3.5 py-2 rounded-3xl flex items-center font-tomatoGrotesk-reg',
      classNames.container
    )}
    style={{
      ...backdropFilter('blur(10px)'),
      ...style,
    }}
  >
    {icon}
    <span
      className={classnames(
        { 'ml-2': !!icon },
        'text-white font-bold align-middle inline-block text-opacity-50',
        classNames.text
      )}
    >
      {text}
    </span>
  </div>
)

Badge.propTypes = {
  text: PropTypes.string,
  classNames: PropTypes.shape({
    text: PropTypes.string,
    container: PropTypes.string,
  }),
}

Badge.defaultProps = {
  classNames: {},
}

export default Badge
